<!--
 * @Version      : V1.0
 * @Date         : 2025-03-25 15:16:29
 * @fileName     : 我的立项
 * @Description  :
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="项目编号" porp="projectCode">
            <el-input v-model="formInline.projectCode" placeholder="项目编号"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" porp="projectName">
            <el-input v-model="formInline.projectName" placeholder="项目名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <el-button type="success" @click="addItem()" v-hasPermi="['project:myProject:add']">新增</el-button>
      <!-- <el-button type="primary">导出</el-button>
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #projectStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.projectStatus).type" effect="dark">{{
              formatterState(row.projectStatus).text }}</el-tag>
          </div>
        </template>
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
            <el-button type="text" @click="change(row)" v-if="row.projectStatus == 2">变更</el-button>
            <el-button type="text" @click="reAdd(row)" v-if="row.projectStatus !== 0 && row.projectStatus !==9">重新发起</el-button>
            <el-button type="text" @click="withdraw(row)" v-if="row.projectStatus == 1">撤销</el-button>
            <el-button type="text" @click="edit(row)" v-if="row.projectStatus == 0 || row.projectStatus == 3|| row.projectStatus == 9">修改</el-button>
            <el-button type="text" @click="detele(row)" v-if="row.projectStatus == 0|| row.projectStatus == 9">删除</el-button>
          </div>
        </template>
      </tableComponent>
    </div>
    <myProjectDetails ref="myProjectRefs" @initQueryData="queryData" :title="detailsT" :status="preStatus">
    </myProjectDetails>
  </div>
</template>

<script>
import myProjectDetails from './myProjectDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { queryProjectApi, deleteProjectApi, withdrawProjectApi } from '@/api/project/index'
import { formatterState } from '@/utils/index'
export default {
  components: {
    tableComponent,
    myProjectDetails
  },
  data() {
    return {
      loading: false,
      detailsT: '我的立项详情',
      formInline: {
        projectCode: "",
        projectName: "",
        createByName: ""
      },
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "项目编号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "80px",
          keyName: "projectCode", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "项目名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "auto",
          keyName: "projectName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "项目类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "108px",
          keyName: "projectTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "客户负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerChargePerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "我方负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "ownerChargePersonName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "预计项目金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "estimatedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "项目周期（天）", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "80px",
          keyName: "projectDurationDays", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "130px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 13,
          title: "项目状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "80px",
          keyName: "projectStatus", // 数据的属性值
          align: "center",
          slotName: "projectStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 16,
          title: "操作", // 标题名称
fixed:"right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "", // 数据的属性值
          align: "center",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.queryData()
  },
  methods: {
    formatterState,
    queryData() {
      this.initData()
    },
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            projectCode: "",
            projectName: "",
            createByName: "",
            ...this.formInline
          }
        },
        ...item
      }
      this.loading = true;
      queryProjectApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    resetData(formName) {
      this.formInline.projectCode = "";
      this.formInline.projectName = "";
      this.$nextTick(() => {
        this.initData()
      })
    },
    addItem() {
      this.preStatus = 'add'
      this.detailsT = '我的立项新增'
      this.$refs.myProjectRefs.openDrawer({})
    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '我的立项详情'
      this.$refs.myProjectRefs.openDrawer(row)
    },
    change(row) {
      this.preStatus = 'change'
      this.detailsT = '我的立项变更'
      this.$refs.myProjectRefs.openDrawer(row)
    },
    reAdd(row){
      this.preStatus = 'reAdd'
      this.detailsT = '我的立项重新发起'
      this.$refs.myProjectRefs.openDrawer(row)
    },
    edit(row) {
      this.preStatus = 'edit'
      this.detailsT = '我的立项编辑'
      this.$refs.myProjectRefs.openDrawer(row)
    },
    detele(row) {
      this.$confirm('确定要删除该项目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        deleteProjectApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    withdraw(row){
      this.$confirm('确定要撤销该项目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        withdrawProjectApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {}
}
</style>
